
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import FileUpload from "@common/src/components/scope/file-upload/index.vue";
import t from "@common/src/i18n/t";
const marketing = namespace("marketing");
@Component({
  components: { FileUpload }
})
export default class MiniProgramSetting extends Vue {
  @marketing.Action queryMiniProgramQrByStore;
  @marketing.Action updateStoreInfoByWeChat;
  @marketing.Action queryStoreInfoByWeChat;

  settingForm = {
    id: "defalut",
    closingTime: "",
    openingTime: "",
    servicePhone: "",
    storePhoto: [],
    openReservation: 1,
    businessHours: ["0900", "1700"],
    SaturdayHours: ["0900", "1700"],
    SundayHours: ["0900", "1700"],
    monToFriday: {
      scheduleDayOfWeek: "8",
      scheduleEndHour: "",
      scheduleStartHour: "",
      scheduleType: 1,
      status: 1
    },
    saturday: {
      scheduleDayOfWeek: "6",
      scheduleEndHour: "",
      scheduleStartHour: "",
      scheduleType: 1,
      status: 1
    },
    sunday: {
      scheduleDayOfWeek: "7",
      scheduleEndHour: "",
      scheduleStartHour: "",
      scheduleType: 1,
      status: 1
    }
  };
  storeQrUrl: string = "";
  settingFormRules = {
    storePhoto: {
      type: "array",
      required: true,
      message: t("v210831.please-upload-store-img"),
      trigger: "change"
    },
    businessHours: {
      type: "array",
      required: true,
      message: t("v210831.please-select-business"),
      trigger: "change"
    },
    servicePhone: { required: true, message: t("v210831.please-enter-external"), trigger: "blur" },
    openReservation: { required: true, message: t("v210831.please-select-whether-or-subscribe"), trigger: "blur" },
    openSpeedWork: { required: true, message: t("v210831.please-select-whether-or-subscribe"), trigger: "blur" }
  };
  created() {
    this.init();
  }
  photoDefaultList = [];
  init() {
    this.queryStoreInfoByWeChat().then(data => {
      // 处理时间
      Object.assign(this.settingForm, data.data);
      const { monToFriday, saturday, sunday } = data.data;
      this.settingForm.SundayHours = [sunday.scheduleStartHour, sunday.scheduleEndHour];
      this.settingForm.businessHours = [monToFriday.scheduleStartHour, monToFriday.scheduleEndHour];
      this.settingForm.SaturdayHours = [saturday.scheduleStartHour, saturday.scheduleEndHour];
      if (data.data?.storePhoto?.length) {
        this.photoDefaultList = data.data.storePhoto.map(item => ({ url: item }));
      }
    });
    this.queryMiniProgramQrByStore().then(data => {
      this.storeQrUrl = data.data;
    });
  }

  submitForm() {
    (this.$refs.settingForm as any).validate(valid => {
      if (valid) {
        this.settingForm.saturday.scheduleStartHour = String(this.settingForm.SaturdayHours[0]);
        this.settingForm.sunday.scheduleStartHour = String(this.settingForm.SundayHours[0]);
        this.settingForm.sunday.scheduleEndHour = String(this.settingForm.SundayHours[1]);
        this.settingForm.monToFriday.scheduleEndHour = String(this.settingForm.businessHours[1]);
        this.settingForm.saturday.scheduleEndHour = String(this.settingForm.SaturdayHours[1]);
        this.settingForm.monToFriday.scheduleStartHour = String(this.settingForm.businessHours[0]);
        this.updateStoreInfoByWeChat(this.settingForm).then(() => {
          this.$message.success(t("v210831.saved-successfully"));
        });
      }
    });
  }
  handleDownloadQr() {
    this.queryMiniProgramQrByStore().then(data => {
      this.storeQrUrl = data.data;
      window.open(this.storeQrUrl);
    });
  }
  handleBannerUploadSuccess() {
    (this.$refs.settingForm as any).validateField("storePhoto");
  }
}
